import type { IPaymentLogo } from '@/components/main-footer/types'

export const PAYMENT_LOGOS: Record<string, IPaymentLogo> = {
  'apple-pay': {
    title: 'apple',
    width: 66,
    height: 42
  },
  amex: {
    title: 'amex',
    width: 42,
    height: 42
  },
  mastercard: {
    title: 'mastercard',
    width: 54,
    height: 42
  },
  visa: {
    title: 'visa',
    width: 70,
    height: 22
  },
  bitpay: {
    title: 'bitpay',
    width: 72,
    height: 29
  },
  'google-pay': {
    title: 'google',
    width: 69,
    height: 33
  },
  klix: {
    title: 'klix',
    width: 58,
    height: 42
  },
  paypal: {
    title: 'paypal',
    width: 76,
    height: 18
  },
  trustly: {
    title: 'trustly',
    width: 72,
    height: 24
  },
  uatp: {
    title: 'uatp',
    width: 70,
    height: 21
  }
}
